var mainBody = document.querySelector('body')
var listCollection = Array.from(document.querySelectorAll('.mh-collection-grid-item'));

listCollection.forEach(function(collection) {
  let collectionPopupBtn = this.document.querySelector('.collection-popup-text');
  let collectionPopup = this.document.querySelector('.collection-popup-wrap');
  let collectionPopupClose = this.document.querySelector('.collection-popup-close');
  let collectionPopupCloseAlt = this.document.querySelector('.collection-popup-close-alt');

  collectionPopupBtn.addEventListener('click', function() {
    mainBody.classList.add("popup-active")
    collectionPopup.classList.add("active")
  })
  
  collectionPopupClose.addEventListener('click', function() {
    mainBody.classList.remove("popup-active")
    collectionPopup.classList.remove("active")
  })
  
  collectionPopupCloseAlt.addEventListener('click', function() {
    mainBody.classList.remove("popup-active")
    collectionPopup.classList.remove("active")
  })
})